import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

const DISMISS_KEY = "pwa-banner-dismissed";

export default function InstallPWABanner() {
  const [canPrompt, setCanPrompt] = useState(!!window.__deferredInstallPrompt);
  const [dismissed, setDismissed] = useState(sessionStorage.getItem(DISMISS_KEY) === "1");
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onAvailable = () => setCanPrompt(true);
    const onInstalled = () => setInstalled(true);
    window.addEventListener("pwa-install-available", onAvailable);
    window.addEventListener("pwa-installed", onInstalled);
    return () => {
      window.removeEventListener("pwa-install-available", onAvailable);
      window.removeEventListener("pwa-installed", onInstalled);
    };
  }, []);

  if (installed || dismissed || !canPrompt) return null;

  const install = async () => {
    const p = window.__deferredInstallPrompt;
    if (!p) return;
    p.prompt();
    try {
      await p.userChoice;
    } catch (_) {}
    window.__deferredInstallPrompt = null;
    setCanPrompt(false);
  };

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      className="lg:hidden mb-4 rounded-2xl border border-[#EADBCE] bg-white p-3 flex items-center gap-3 shadow-sm"
      data-testid="install-banner"
    >
      <div className="shrink-0 w-11 h-11 rounded-xl bg-[#FF7878] text-white flex items-center justify-center">
        <Download className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-display font-bold text-sm text-[#4A3B32] leading-tight">
          Instala Darkar Co.
        </p>
        <p className="text-xs text-[#8A796F]">Acceso rápido desde tu pantalla de inicio.</p>
      </div>
      <button
        onClick={install}
        data-testid="install-banner-button"
        className="rounded-full bg-[#FF7878] hover:bg-[#FF5C5C] text-white text-sm font-bold px-4 py-2 active:scale-95 transition-transform"
      >
        Instalar
      </button>
      <button
        onClick={dismiss}
        aria-label="Cerrar"
        data-testid="install-banner-dismiss"
        className="rounded-full p-1.5 text-[#8A796F] hover:bg-[#FCF9F2]"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
